import * as React from 'react';
import { FacebookEmbed } from 'react-social-media-embed';
import { SocialEmbedContainer } from '../socialEmbedContainer';
export var Facebook = function (props) {
    var link = props.link;
    return (React.createElement(SocialEmbedContainer, null,
        React.createElement(FacebookEmbed, { url: link, width: "350px" })));
};
